import { useContext, useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { sessIdCookieName } from '../sharedF/cookiesF.mts'
import * as _ from 'lodash-es'
import { randomUrlSafeBytes } from '../sharedF/randomBytesF.mts'
import { SessIdCtx } from './SessIdCtxF.tsx'
import { sessIdLength } from '../sharedF/sessIdTypeF.mts'

/** @typedef {import('../sharedF/sessIdTypeF.mts').sessIdType} sessIdType */
import { PtSiteCtx } from './CustomSiteF/CustomSiteWrapperF.jsx'
import { guardValidSessId } from '../sharedF/validateSessIdF.mts'
import { throwIf } from '../sharedF/throwErrorF/throwIfF.mts'

const cookiesApi = Cookies.withAttributes({ expires: 365, sameSite: 'strict' })

const getCookSessId = () => {
  return cookiesApi.get(sessIdCookieName)
}

const setCookSessId = (sessId) => {
  cookiesApi.set(sessIdCookieName, sessId)
}

export const SsidWrapper = ({children}) => {
  let {genSessId} = /** @type {{genSessId?: () => string}} */ (useContext(PtSiteCtx))

  const [sessId, setStateSessId] = useState(/** @type {sessIdType | undefined} */ (undefined))
  const existCtx = useContext(SessIdCtx)

  throwIf(() => existCtx, {existCtx})

  genSessId ||= () => randomUrlSafeBytes(sessIdLength)

  /** @param {string} sessId */
  const setSessId = (sessId) => {
    guardValidSessId({sessId})
    const validSessId = /** @type {sessIdType} */ (sessId)
    setCookSessId(validSessId)
    setStateSessId(validSessId)
  }

  useEffect(() => {
    const cookieVal = getCookSessId()
    if (cookieVal) {
      setStateSessId(/** @type {sessIdType} */ (cookieVal))
      return
    }
    setSessId(genSessId())
  }, [])

  return <SessIdCtx.Provider {...{children, value: {sessId, setSessId}}} />
}
